import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router'
import http from '@/utils/request'
import '../src/assets/scss/common.scss';
import '../src/assets/scss/style.css';
import dataV from '@jiaminghi/data-view'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'STLLkTgxwQbLqbTryXhVHmjNBvHYZF5j'
})

import VueSlider from 'vue-slider-component' // 时间滑块插件
import 'vue-slider-component/theme/default.css'
Vue.component('VueSlider', VueSlider)


Vue.use(dataV)
Vue.use(Vuex);
Vue.use(ElementUI);

Vue.prototype.$http = http;

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
